import axiosInstance from "../../setupAxios";
import { IRegisterViewModel } from "../types/IRegisterViewModel";
import { ILoginViewModel } from "../types/ILoginViewModel";
import { Promise } from "es6-promise";
import { IRegistrationResponse } from "../types/IRegistrationResponse";
import { IViewAsAccessRequest } from "../../membersportal/types/IViewAsAccessRequest";
import { IApplication } from "../../membersportal/types/IApplication";
import { IUserCRMValues } from "../../membersportal/types/IUserCRMValues";
import { ICase } from "../../membersportal/types/ICase";
import { IAccountSocietyAffiliation } from "../../membersportal/types/IAccountSocietyAffiliation";
import { IRequestViewAsAccessModel } from "../../membersportal/types/IRequestViewAsAccessModel";

export class AccountService {

    public static register(
        viewModel: IRegisterViewModel
    ): Promise<IRegistrationResponse> {
        return new Promise<IRegistrationResponse>((resolve, reject) => {
            axiosInstance
                .post("Account/Register", viewModel)
                .then(res => {
                    if (res.data.success) {
                        sessionStorage.username = "";
                    }

                    resolve({ success: res.data.success, errors: res.data.errors });
                })
                .catch(res => {
                    resolve({ success: false, errors: res.data.errors });
                });
        });
    }

    public static login(postData: ILoginViewModel): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            axiosInstance
                .post("Account/Login", postData)
                .then(res => {
                    if (res.status === 200) {
                        resolve(res.data);
                    }
                    else {
                        reject(res);
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    public static logout(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .get("Account/Logout")
                .then(res => {
                    resolve(true);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    public static async getAADLoginConfiguration() {
        const response = await axiosInstance
            .get("Account/AADLoginConfiguration")
        return response.data
    }

    public static async getB2CLoginConfiguration() {
        const response = await axiosInstance
            .get("Account/B2CLoginConfiguration")
        return response.data
    }

    public static loginType(): Promise<string> {
        return new Promise<string>((resolve, reject) => {
            axiosInstance
                .get("Account/LoginTypeFeatureSwitch")
                .then(res => {
                    if (res.status === 200) {
                        resolve(res.data);
                    }
                    else {
                        reject(res);
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    public static requestViewAsAccess(
        model: IRequestViewAsAccessModel
    ): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post("Account/RequestViewAsAccess", model)
                .then(res => {
                    resolve(res.data);
                })
                .catch(res => {
                    resolve(res.data);
                });
        });
    }

    public static getUserCRMValues(): Promise<IUserCRMValues> {
        return new Promise<IUserCRMValues>((resolve, reject) => {
            axiosInstance
                .get("Account/GetUserCRMValues")
                .then(res => {
                    if (res.status === 200) {
                        resolve(res.data);
                    }
                    else {
                        reject(res);
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    public static getUserCRMIpNumber(
        guid: string
    ): Promise<IUserCRMValues> {
        return new Promise<IUserCRMValues>((resolve, reject) => {
            axiosInstance
                .get("Account/GetUserCRMIpNumber/" + guid)
                .then(res => {
                    if (res.status === 200) {
                        resolve(res.data);
                    }
                    else {
                        reject(res);
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    public static getViewAsAccessRequests(
        userName: string
    ): Promise<IViewAsAccessRequest[]> {
        return new Promise<IViewAsAccessRequest[]>((resolve, reject) => {
            axiosInstance
                .get("Account/GetViewAsAccessRequests", { params: { userName } })
                .then(res => {
                    const viewAsAccessRequests = [];

                    for (let x = 0; x < res.data.length; x++) {
                        const viewAsAccessRequest = {
                            accountNumber: res.data[x].accountNumber,
                            ipName: res.data[x].ipName,
                            ipiNumber: res.data[x].ipiNumber,
                            status: res.data[x].status,
                            defaultAccess: res.data[x].defaultAccount,
                            guid: res.data[x].guid,
                            accountId: res.data[x].accountId,
                            viewAs: res.data[x].viewAsAccount
                        };

                        viewAsAccessRequests.push(viewAsAccessRequest);
                    }
                    resolve(viewAsAccessRequests);

                })
                .catch(res => {
                    //resolve(res.data);
                });
        });
    }

    public static getMyApplications(
    ): Promise<IApplication[]> {
        return new Promise<IApplication[]>((resolve, reject) => {
            axiosInstance
                .get("Account/GetMyApplications")
                .then(res => {
                    const applications = [];

                    for (let x = 0; x < res.data.length; x++) {
                        const application = {
                            applicationId: res.data[x].applicationId,
                            name: res.data[x].name,
                            submittedDateTime: res.data[x].submittedDateTime,
                            status: res.data[x].status,
                            guid: res.data[x].guid,
                            lastModifiedDate: res.data[x].lastModifiedDateTime,
                            memberType: res.data[x].memberType
                        };

                        applications.push(application);
                    }
                    resolve(applications);

                })
                .catch(res => {
                    reject(res.data);
                });
        });
    }

    public static getMyCases(): Promise<ICase[]> {
        var language = JSON.parse(localStorage.getItem('userLanguagePreferences'));
        return new Promise<ICase[]>((resolve, reject) => {
            axiosInstance
                .get("Account/GetMyCases", { params: { language: language } })
                .then(res => {
                    const cases = [];

                    for (let x = 0; x < res.data.length; x++) {
                        const caseReturn = {
                            ticketNumber: res.data[x].ticketNumber,
                            createdBy: res.data[x].createdBy,
                            title: res.data[x].title,
                            caseType: res.data[x].caseType,
                            caseOrigin: res.data[x].caseOrigin,
                            submittedDateTime: res.data[x].submittedDateTime,
                            status: res.data[x].status,
                            subject: res.data[x].subjectId,
                            guid: res.data[x].guid,
                            lastModifiedDate: res.data[x].lastModifiedDateTime

                        };

                        cases.push(caseReturn);
                    }
                    resolve(cases);

                })
                .catch(res => {
                    reject(res.data);
                });
        });
    }

    public static getCurrentUserSocietyAffiliation(): Promise<IAccountSocietyAffiliation> {
        var language = JSON.parse(localStorage.getItem('userLanguagePreferences'));
        return new Promise<IAccountSocietyAffiliation>((resolve, reject) => {
            axiosInstance
                .get("Account/GetCurrentUserSocietyAffiliation", { params: { language: language } })
                .then(res => {
                    if (res.status === 200) {
                        resolve(res.data);
                    }
                    else {
                        reject(res);
                    }
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    public static setViewAsDefaultAccount(
        defaultAccount: string,
        viewAsAccountNumber: string,
        userName: string
    ): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post("Account/SetViewAsDefaultAccount/", { AccountNumber: defaultAccount, viewAsAccountNumber: viewAsAccountNumber, UserName: userName })
                .then(res => {
                    resolve(res.data);

                })
                .catch(res => {
                    reject(res.data);
                });
        });
    }

    public static cancelAccessRequest(
        defaultAccount: string,
        userName: string
    ): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            axiosInstance
                .post("Account/CancelAccessRequest/", { AccountNumber: defaultAccount, UserName: userName })
                .then(res => {
                    resolve(res.data);

                })
                .catch(res => {
                    reject(res.data);
                });
        });
    }
}
